/**
 * 枚举值类型
 */
export declare type ValueFormat = 'int32' | 'string' | 'int64' | '';

/**
 * 枚举记录
 */

export interface EnumItem {
  key: string; // 枚举字段
  value: string; // 枚举值
  description?: string; // 枚举描述
  isValid?: boolean; // 是否使用该字段
  default?: boolean; // 是否默认
}

/**
 * 关联接口信息
 */
export interface InterfaceItem {
  interfaceId: string; // 接口id
  environmentId: string; // 环境id
  serviceId: string; // 服务id
  title: string; // 接口描述
  path: string; // 接口路径
  expired: boolean; // 枚举是否过期
  fields: string[];
  usePart: boolean;
}

/**
 * 枚举包
 */
export interface EnumPackage {
  teamId: string; // 团队ID
  id: string; // 枚举包ID
  name: string; // 名称
  keyFormat?: string; // 类型 (文档没有定义，返回结果有)
  valueFormat: ValueFormat; // 枚举值类型
  enums: EnumItem[]; // 枚举列表
  fields?: string[]; // 使用到该枚举包的所有字段
  interfaces?: InterfaceItem[]; // 接口前缀
  creator?: {
    staffName: string; // 创建人中文名称
    userName: string; // 创建人邮箱前缀
  };
  updateTime?: string;

  expired?: boolean; // 是否过期
}

/**
 * 抽屉组件模式
 */
export enum EnumDrawerMode {
  None = 0,
  New = 1,
  Edit = 2,
  View = 3,
}
